<script setup>
import { computed, inject, toRaw } from 'vue';
import {
  ArrowDown01Icon,
  ArrowLeft01Icon,
  ArrowRight01Icon,
  ArrowUp01Icon,
  Delete03Icon,
  Edit04Icon,
  PencilEdit02Icon,
  Refresh01Icon,
  SendHorizontalIcon,
  UserMinus01Icon,
  UserRemove01Icon,
  UserRemove02Icon,
} from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/vue';
import FontIcon from './FontIcon.vue';

const props = defineProps({
  icon: {
    type: Array,
    required: true,
  },
  altIcon: {
    type: Array,
    default: null,
  },
  showAlt: {
    type: Boolean,
    default: false,
  },
  size: {
    type: [Number, String],
    default: 20,
  },
  strokeWidth: {
    type: Number,
    default: 1.8,
  },
  absoluteStrokeWidth: {
    type: Boolean,
    default: false,
  },
});

const fontIcons = new Map([
  [ArrowLeft01Icon, 'chevron-left'],
  [ArrowRight01Icon, 'chevron-right'],
  [ArrowUp01Icon, 'chevron-up'],
  [ArrowDown01Icon, 'chevron-down'],
  [Edit04Icon, 'pencil-edit-outline'],
  [PencilEdit02Icon, 'pencil-edit-outline'],
  [Refresh01Icon, 'refresh-outline'],
  [SendHorizontalIcon, 'send-horizontal-outline'],
  [Delete03Icon, 'delete-outline'],
  [UserMinus01Icon, 'unassigned-filled'],
  [UserRemove01Icon, 'unassigned-filled'],
  [UserRemove02Icon, 'unassigned-filled'],
  ...inject('customFontIcons', []),
]);
const displayedIcon = computed(() =>
  props.showAlt && props.altIcon ? props.altIcon : props.icon
);
const fontIcon = computed(() => fontIcons.get(toRaw(displayedIcon.value)));
const fontStrokeWidth = computed(() =>
  [1, 1.25, 1.5, 1.75, 2].reduce((closest, weight) =>
    Math.abs(weight - props.strokeWidth) < Math.abs(closest - props.strokeWidth)
      ? weight
      : closest
  )
);

defineOptions({
  inheritAttrs: false,
});
</script>

<template>
  <FontIcon
    v-if="fontIcon"
    v-bind="$attrs"
    :icon="fontIcon"
    :size="Number(size)"
    :stroke-width="fontStrokeWidth"
    class="leading-none"
  />
  <HugeiconsIcon
    v-else
    v-bind="$attrs"
    :icon="icon"
    :alt-icon="altIcon"
    :show-alt="showAlt"
    :size="size"
    color="currentColor"
    :stroke-width="strokeWidth"
    :absolute-stroke-width="absoluteStrokeWidth"
  />
</template>
